@if (config().visible) {
  <div class="row" [formGroup]="formGroup">
    @if (config().label) {
      <label>{{ config().i18nKey() | ppLabel: config().label }}</label>
    }
    @for (radio of config().getSelectables(); track radio.key; let i = $index) {
      <div [ngClass]="config().styleClass ? config().styleClass : ''">
        <input type="radio" class="form-check-input" [id]="config().attrName + i" formControlName="{{ config().attrName }}" [value]="radio.key" />
        <label [for]="config().attrName + i" [ngClass]="config().labelClass ? config().labelClass : ''">{{ radio.value }}</label>
      </div>
    }
  </div>
}
